/* eslint-disable react/jsx-no-undef */
import * as React from 'react';
import { CenterAlignedRow } from 'components/Styled/Layout/CenterAlignedRow';
import { Col, Form, Input, Row, Button, Descriptions, Modal } from 'antd';
import FormControl from 'components/Forms/FormControl';
import { FormComponentProps } from 'antd/lib/form';
import { withRouter, RouteComponentProps, NavLink } from 'react-router-dom';
import ValidationUtility from 'Core/ValidationUtility';
import UserProfileHandler from '../UserProfileHandler';
import { IResetPasswordCommandRequest, IChangePasswordCommandRequest, SlimDocument } from 'Core/Api/Api';
import FormItem from 'antd/lib/form/FormItem';
import NotificationService from 'Core/NotificationService';
import ConfigService from 'Core/ConfigService';
import Title from 'antd/lib/typography/Title';
import { BorderlessDescriptions } from '../../Offering/OfferingDetailsView';
import { WhiteBackgroundCard, singleColFormColSize } from '../../Forms/Form.Styled';
import { startCase } from 'lodash';
import moment from 'moment';
import { RightAlignedRow } from '../../Styled/Layout/RightAlignedRow';
import uploadImg from '../../../assets/images/upload.png';
import editProfileImg from '../../../assets/images/edit-profile.png';
import changePasswordImg from '../../../assets/images/change-password.png';
import securityQuestionImg from '../../../assets/images/security-question.png';


export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    profile?: any,
    documentUrl?: string,
    document?: SlimDocument,
    documentModal: boolean
}

export class UserProfileFormWithoutFormsAndRouter extends React.Component<Props, State> {
    handler: UserProfileHandler;

    constructor(props: Props) {
        super(props);

        this.state = { documentModal: false };
        this.handler = new UserProfileHandler(props);
    }

    componentDidMount() {
        this.getProfileInfo();
    }

    getProfileInfo() {
        this.handler.GetProfileInfo({}).then(
            x => {
                this.setState({ profile: x });
            },
            x => NotificationService.error(x.message)
        )
    }

    handleCancel = e => {
        this.setState({
            documentModal: false
        });
    };

    showDocument = (doc) => {
        this.setState({
            documentUrl: doc?.documentUrl,
            documentModal: true,
            document: doc
        });
    };


    onSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.props.form.validateFields((error, values: IChangePasswordCommandRequest) => {
            if (error) {
                return;
            }

            this.handler.ChangePassword(values).then(() => {
                this.props.history.push('/login');
                NotificationService.success('Password has been updated');
            });
        });
    };

    render() {
        var { getFieldDecorator } = this.props.form;
        var passwordValidations = ValidationUtility.password;
        var compareValidations = ValidationUtility.compare;
        return (
            <Row type="flex" justify="center">
                <Col span={16}>
                    <WhiteBackgroundCard>

                        <Modal
                            title={"Uploaded Document"}
                            visible={this.state.documentModal}
                            onCancel={this.handleCancel}
                            footer={[
                                <Button key="back" onClick={this.handleCancel}>
                                    Cancel
                                </Button>
                            ]} >

                            <img src={this.state.documentUrl} width='100%' />
                            {this.state.document?.comments ?
                                <>
                                    <br />
                                    <br />
                                    <p>Comments: {this.state.document?.comments}</p>
                                </> : ''}
                        </Modal>

                        <Row>
                            <Col >
                                <Row type="flex">
                                    <Col span={24} style={{ paddingTop: "75px" }}>
                                        <Row><Col span={12}>
                                            <Title>User Profile </Title>
                                        </Col>
                                            <Col span={12} style={{ textAlign: 'right' }} >
                                                <NavLink to="/upload-user-docs" style={{ paddingLeft: '10px' }}><img src={uploadImg} height={40} title="Upload Documents" alt="Upload Documents" ></img> </NavLink>
                                                <NavLink to="/edit-user-profile" style={{ paddingLeft: '10px' }}><img src={editProfileImg} height={40} title="Edit Profile" alt="Edit Profile"></img> </NavLink>
                                                <NavLink to="/change-password" style={{ paddingLeft: '10px' }}><img src={changePasswordImg} height={40} title="Change Password" alt="Change Password"></img> </NavLink>
                                                <NavLink to="/update-security" style={{ paddingLeft: '10px' }}><img src={securityQuestionImg} height={40} title="Change Security Questions" alt="Change Security Questions"></img> </NavLink>
                                            </Col>
                                        </Row>
                                        <BorderlessDescriptions bordered column={1} >
                                            <Descriptions.Item label="First Name" >
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.profile?.firstName}
                                                </div>
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Last Name" >
                                                <strong>{this.state.profile?.lastName}</strong>
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Phone Number" >
                                                <strong>{this.state.profile?.phoneNumber}</strong>
                                            </Descriptions.Item>
                                        </BorderlessDescriptions>

                                    </Col>
                                </Row>
                            </Col>



                        </Row>

                        {this.state.profile?.documents ?
                            <Row>
                                <Col span={14} style={{ paddingTop: "75px" }}>
                                    <Descriptions
                                        column={1}
                                        size={'small'}
                                        title={"Uploaded Documents"} bordered >
                                        {
                                            this.state.profile?.documents?.map(doc => {
                                                return <Descriptions.Item label={startCase(doc.documentType)} >
                                                    {<>Uploaded: {moment(doc.dateUploaded).format('MMM DD, YYYY')} <Button style={{ marginLeft: '30px' }} onClick={() => this.showDocument(doc)}> View  </Button>
                                                    </>}
                                                </Descriptions.Item>
                                            })
                                        }

                                    </Descriptions>
                                </Col >
                            </Row> : ''
                        }
                    </WhiteBackgroundCard>

                </Col>

            </Row>
        );
    }
}

const UserProfileFormWithoutRouter = Form.create<Props>({
    name: 'UserProfileForm',
})(UserProfileFormWithoutFormsAndRouter);

const UserProfileForm = withRouter(UserProfileFormWithoutRouter);

export default UserProfileForm;
